import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: 'mojo-about-page',
  templateUrl: './about-page.component.html'
})
export class AboutPageComponent implements OnInit, OnDestroy {

  returnUrl: string;
  routeSubscription: Subscription;

  constructor(private readonly route: ActivatedRoute) {
  }

  ngOnInit() {
    this.routeSubscription = this.route.queryParams.subscribe(params => {
      this.returnUrl = params.returnUrl
    })
  }

  onDisplayChange(display: boolean) {
    if (!display) {
      window.location.href = this.returnUrl
    }
  }

  ngOnDestroy() {
    if (this.routeSubscription != null)
      this.routeSubscription.unsubscribe()
  }
}
